export default "__VITE_ASSET__s1EZ1Al4__"